/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-ignore */
// @ts-nocheck
import React, { useEffect } from "react";
import api from "services/api";
import { useAuth } from "hooks/authHook";

type UserData = {
  corporateName: string;
  email: string;
  phoneNumber: string;
  phoneDdd: string;
  phoneNumber: string;
  document: string;
};

const nonLoggedScriptUrl =
  "https://www5.directtalk.com.br/clientes/custom/AeC_Ultragaz_2/widget.min.js";
const loggedScriptUrl =
  "https://www5.directtalk.com.br/clientes/custom/AeC_Ultragaz/widget.min.js";

const ChatTwillo: React.FC = () => {
  const { userData } = useAuth();

  const getUserData = async (): Promise<UserData> => {
    const header = {
      "Content-Type": "application/json",
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };
    const parameters = {
      method: "GET",
      headers: header,
    };

    const response = await api.get(
      "industrial/customer/v1/customers/me",
      parameters
    );

    return response.data;
  };

  const clearPreviousElements = (): void => {
    [
      "dt-widget",
      "bot",
      "dtbot-iframe",
      "hi-custom-widget",
      "widget-style",
      "dtbot-script",
    ].forEach((id) => document.getElementById(id)?.remove());
  };

  const loadScript = (source): void => {
    clearPreviousElements();

    const scriptBot = document.createElement("script");
    scriptBot.src = source;
    scriptBot.id = "dt-widget";
    document.body.appendChild(scriptBot);

    setInterval(() => {
      const dtBOTfloaterchat = document.getElementsByClassName("dt-BOTfloater");
      for (let i = 0; i < dtBOTfloaterchat.length; i += 1) {
        if (dtBOTfloaterchat[i]) {
          dtBOTfloaterchat[i].remove();
        }
      }
    }, 10);
  };

  const loadScriptForLoggedUser = async (): void => {
    const userDataResponse = await getUserData();

    loadScript(
      `${loggedScriptUrl}?nome_usuario=${
        userDataResponse.corporateName || "Sem nome"
      }&email=${userDataResponse.email || "noemail@noemail.com"}&telefone=${
        userDataResponse.phoneNumber
          ? `${userDataResponse.phoneDdd || ""}${
              userDataResponse.phoneNumber || ""
            }`
          : "(12) 4001-9000"
      }&cpfcnpj=${userDataResponse.document || ""}&termos=termos`
    );
  };

  useEffect(() => {
    if (!userData || Object.keys(userData).length === 0) {
      loadScript(nonLoggedScriptUrl);
    } else {
      loadScriptForLoggedUser();
    }

    return () => {
      clearPreviousElements();
    };
  }, [userData]);

  return <></>;
};

export default ChatTwillo;
